import { Moment } from "moment";
import TextField from "@mui/material/TextField";
import { Controller, useForm } from "react-hook-form";
import {
  IonButton,
  IonCard,
  IonContent,
  IonIcon,
  IonInput,
  IonSelect,
  IonSelectOption,
  useIonRouter,
} from "@ionic/react";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

import "./styles.css";

import { Breeding } from "../../../../models";
import Header from "../../../../components/Header";
import FormControl from "../../../../components/FormControl/FormControl";
import { useGoBack } from "../../../../hooks/useGoBack";
import { useParams } from "react-router";
import { useBreedingForm } from "./useBreedingForm";
import { BreedingAttempt } from "../../../../models/breeding";
import useBreedingService from "../../../../services/useBreedingService";

type RouteParams = { cowId: string };
interface BreedingFormProps {
  title: string;
  breeding?: Partial<Breeding>;
  onFormSubmit: (data: BreedingAttempt) => void;
}
export default function BreedingForm({
  title,
  breeding,
  onFormSubmit,
}: BreedingFormProps): React.ReactElement {
  const router = useIonRouter();
  const { cowId } = useParams<RouteParams>();
  const { sires } = useBreedingForm();
  const {
    reset,
    control,
    setValue,
    register,
    handleSubmit,
    formState: { isValid, isDirty },
  } = useForm<BreedingAttempt>({
    defaultValues: {
      aiTech: breeding?.aiTech || "",
      sireId: breeding?.sireId || "",
      attemptDate: breeding?.attemptDate || undefined,
    },
  });

  const goBack = useGoBack({
    guardValue: isDirty,
    navigateTo: `/cows/${cowId}`,
    routerDirection: "back",
    onOkGuardHandler: () => {
      reset();
    },
  });

  const onSubmit = handleSubmit((data) => {
    onFormSubmit(data);
  });

  const { deleteBreedingAttempt } = useBreedingService();

  const onDelete = async () => {
    if (breeding) {
      await deleteBreedingAttempt(breeding.id!);
      router.push(`/cows/${cowId}`);
    }
  };

  return (
    <>
      <form onSubmit={onSubmit} className={"BreedingForm"}>
        <Header
          title={title}
          onGoBack={goBack}
          rightComponent={
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 10,
              }}
            >
              {breeding && (
                <IonButton size={"small"} fill={"clear"} onClick={onDelete}>
                  <IonIcon src={"assets/trash.svg"} color={"danger"} />
                </IonButton>
              )}
              <IonButton
                fill="clear"
                type="submit"
                disabled={!isValid}
                style={{ color: "#4888AE" }}
              >
                Save
              </IonButton>
              {/* {breeding && <IonButton onClick={onDelete}>Delete</IonButton>} */}
            </div>
          }
        />
        <IonContent>
          <IonCard>
            <FormControl label={"Attempt Date"}>
              <Controller
                name="attemptDate"
                control={control}
                render={({ field }) => (
                  <MobileDatePicker
                    closeOnSelect
                    value={field.value || null}
                    inputFormat="MM/DD/YYYY"
                    onChange={(e: Moment | null) => {
                      setValue("attemptDate", e?.format("MM/DD/YYYY") || "", {
                        shouldDirty: true,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size={"small"}
                        fullWidth
                        style={{ marginTop: 10 }}
                      />
                    )}
                  />
                )}
              />
            </FormControl>
            <FormControl label={"Sire ID"}>
              <Controller
                name="sireId"
                control={control}
                render={({ field }) => (
                  <IonSelect
                    value={field.value}
                    placeholder="Select"
                    onIonChange={(e: any) => setValue("sireId", e.target.value)}
                  >
                    {sires.map((sire) => (
                      <IonSelectOption key={sire.id} value={sire.id}>
                        {sire.sireName}
                      </IonSelectOption>
                    ))}
                  </IonSelect>
                )}
              />
            </FormControl>
            <FormControl label={"AI Tech"}>
              <IonInput
                {...register("aiTech")}
                type={"text"}
                placeholder="AI Tech"
              />
            </FormControl>
          </IonCard>
        </IonContent>
      </form>
    </>
  );
}
